<!-- 教育局-课酬管理 -->
<template>
  <div>
    <div class="index" v-if="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <!-- <div class="Homeboxtop_nav_tab">
        时间：
        <el-date-picker
          style="width: 300px"
          v-model="queryParams.data"
          type="daterange"
          range-separator=""
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div> -->
      <!-- <div
        class="Homeboxtop_nav_tab"
        v-if="!educationType"
        style="margin-top: 30px"
      >
        <span
          v-for="(item, index) in tabList"
          :class="['res-tab', { active: item.area_name === tabName }]"
          :key="index + item.area_name"
          @click="tabClick(item)"
        >
          {{ item.area_name }}
        </span>
      </div> -->
      <div class="totalData">
        <div class="totalItime">
          <span class="totalItime_left"
            >￥{{ educationType ? 19298 : 210298 }}
          </span>
          <span class="totalItime_right">学校教师课酬(元)</span>
        </div>
        <div class="totalItime">
          <span class="totalItime_left"
            >￥{{ educationType ? 7617 : 29617 }}</span
          >
          <span class="totalItime_right">校外人员课酬(元)</span>
        </div>
      </div>
      <div style="margin-top: 10px">
        <!-- <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="" label-width="90px">
            <el-input
              v-model="queryParams.cname"
              placeholder="请输入课程名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="" label-width="90px">
            <el-input
              v-model="queryParams.unit"
              placeholder="请输入报审单位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form> -->

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <!-- <el-table-column
              prop="a"
              v-if="educationType"
              label="学校"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="a"
              v-else
              label="区域"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column> -->
            <el-table-column prop="b" label="学校教师课酬总金额" align="center">
            </el-table-column>
            <el-table-column
              prop="c"
              label="校外人员课酬总金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="120"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看课酬明细</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail>
  </div>
</template>
<script>
import educationApi from "@/api/education/index.js";
import { getDetail } from "@/api/mechanismApi/curriculum";
import util from "@/utils/util.js";
export default {
  components: {
    Detail: ()=>import('./detail.vue')
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      queryParams: {
        data: "",
      },
      shList: [],
      educationType: sessionStorage.getItem("educationType") === "area",
      tableData: [],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      Userlist: JSON.parse(window.sessionStorage.getItem("Userlist")),
      tabList: [],
      tabName: "全省",
      proviceCode: "", // 省编码
      cityCode: "", // 市编码
      areaCode: "", // 区编码
    };
  },
  watch: {
    tabName(n, o) {
      let arr = this.tabList.filter((e) => e.area_name === n);
      if (this.org_type === "p") {
        if (n === "全省") {
          this.cityCode = "";
        } else {
          this.cityCode = arr[0].area_code;
        }
      } else {
        if (n === "全市") {
          this.areaCode = "";
        } else {
          this.areaCode = arr[0].area_code;
        }
      }
    },
  },
  computed: {},
  mounted() {},
  created() {
    if (this.org_type !== "a") {
      let areaList = JSON.parse(sessionStorage.getItem("areaList")) || [];
      if (this.org_type === "p") {
        this.provinceCode = this.Userlist.province_code;
        this.tabList = [
          { area_name: "全省", parent_code: this.Userlist.province_code },
          ...areaList,
        ];
      } else {
        this.provinceCode = this.Userlist.province_code;
        this.cityCode = this.Userlist.city_code;
        this.tabList = [
          { area_name: "全市", area_code: this.Userlist.city_code },
          ...areaList,
        ];
      }
      this.tabName = this.tabList[0].area_name;
    }
    this.getDataList();
    this.initData();
  },
  methods: {
    initData() {
      if (this.educationType) {
        if (sessionStorage.getItem("platformCode") == "460000") {
          this.tableData = [
            { a: "海口市第九小学", b: "¥4,943.00", c: "¥7,182.00 " },
            { a: "海口市滨海第九小学", b: "¥6,505.00", c: "¥8,193.00 " },
            { a: "海口市第二十五小学 ", b: "¥5,288.00", c: "¥8,271.00 " },
            { a: "海口市英才小学 ", b: "¥2,063.00", c: "¥2,712.00 " },
            { a: "海口市寰岛实验小学", b: "¥2,450.00", c: "¥8,271.00 " },
            { a: "海口市滨海第九小学", b: "¥7,066.00", c: "¥2,819.00 " },
            { a: "海口市第十三小学", b: "¥4,660.00", c: "¥8,721.00 " },
            { a: "海口市龙峰实验小学", b: "¥6,863.00", c: "¥7,281.00 " },
            { a: "海口市琼山第三小学", b: "¥5,623.00", c: "¥8,272.00 " },
            { a: "海口白沙门小学", b: "¥6,769.00", c: "¥4,721.00 " },
          ];
        } else {
          this.tableData = [
            { a: "新河街小学", b: "¥4,943.00", c: "¥7,182.00 " },
            { a: "白鹭街小学", b: "¥6,505.00", c: "¥8,193.00 " },
            { a: "武汉市余家头小学 ", b: "¥5,288.00", c: "¥8,271.00 " },
            { a: "武泰闸小学 ", b: "¥2,063.00", c: "¥2,712.00 " },
            { a: "丁字桥小学", b: "¥2,450.00", c: "¥8,271.00 " },
            { a: "解放桥小学", b: "¥7,066.00", c: "¥2,819.00 " },
            { a: "武昌实验小学", b: "¥4,660.00", c: "¥8,721.00 " },
            { a: "棋盘街小学", b: "¥6,863.00", c: "¥7,281.00 " },
            { a: "徐东路小学", b: "¥5,623.00", c: "¥8,272.00 " },
            { a: "复兴路小学", b: "¥6,769.00", c: "¥4,721.00 " },
          ];
        }
      } else {
        if (sessionStorage.getItem("platformCode") == "460000") {
          this.tableData = [
            { a: " 秀英区 ", b: " ¥27,182.00  ", c: "¥30,000.00   " },
            { a: " 龙华区 ", b: " ¥28,193.00  ", c: "¥50,000.00  " },
            { a: " 琼山区 ", b: " ¥38,271.00  ", c: "¥30,000.00  " },
            { a: " 美兰区 ", b: " ¥82,712.00  ", c: "¥35,000.00 " },
          ];
        } else {
          this.tableData = [
            { a: " 江汉区 ", b: " ¥27,182.00  ", c: "¥30,000.00   " },
            { a: " 青山区 ", b: " ¥28,193.00  ", c: "¥50,000.00  " },
            { a: " 江夏区 ", b: " ¥38,271.00  ", c: "¥30,000.00  " },
            { a: " 武昌区 ", b: " ¥82,712.00  ", c: "¥35,000.00 " },
            { a: " 江汉区 ", b: " ¥38,271.00  ", c: "¥60,000.00 " },
            { a: " 青山区 ", b: " ¥82,819.00  ", c: "¥55,000.00 " },
            { a: " 江夏区 ", b: " ¥98,721.00  ", c: "¥42,000.00 " },
            { a: "武昌区 ", b: " ¥67,281.00  ", c: "¥66,000.00 " },
            { a: " 武昌区", b: " ¥38,272.00 ", c: "¥50,000.00 " },
            { a: " 洪山区", b: " ¥84,721.00 ", c: "¥50,000.00 " },
          ];
        }
      }
    },
    tabClick(item) {
      this.tabName = item.area_name;
    },
    async getDataList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        proviceCode: this.proviceCode, // 省编码
        cityCode: this.cityCode, // 市编码
        areaCode: this.areaCode, // 区编码
        auditState: this.queryParams.auditState,
        cname: this.queryParams.cname,
        reportOrgName: this.queryParams.unit, // 报审单位名称
        auditOrgId: "", // 报审单位id
      };
      let res = await educationApi.getProviceCourseList(params);
      if (res.result === "000000") {
        // this.tableData=res.data?.list || [];
        // this.totalPage = res.data?.total || 0;
        this.totalPage = this.tableData.length;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    async toDetail(item) {
      // let params = {
      //   id: item.cid,
      //   };
      // let paramsData= {
			// cid: item.cid,
			// orgId:sessionStorage.getItem("orgId"),
			// };
      // var { result, data } = await getDetail(params);
      // let res = await educationApi.getEducationCourseauditrecord(paramsData);
      // if (result == "000000") {
      //   this.detail.info = data;
      //   if (res.result === "000000") {
      //     this.detail.info.operateList = res.data || [];
      //   }
      //   this.detail.show = true;
      // } else {
      //   this.$message({
      //     type: "error",
      //     message: "获取信息失败",
      //   });
      // }
       this.detail.show = true;
    },
    // 上架/下架课程
    async toOperate(text, type, item) {
      let vm = this;
      util
        .handleCofirm(text, "info")
        .then(async (res) => {
          let params = {
            cid: item.cid,
            auditState: type,
            operateOpinion: "",
            orgId: sessionStorage.getItem("orgId"),
          };
          let { result } = await educationApi.educationCourseOperate(params);
          if (result == "000000") {
            vm.$message({ type: "success", message: "操作成功" });
            vm.getDataList();
          } else {
            vm.$message({ type: "error", message: "操作失败" });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .totalData {
    width: 100%;
    margin: 20px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    .totalItime {
      width: 50%;
      height: 100px;
      background-color: #f5faff;
      border-radius: 6px;
      text-align: center;
      line-height: 100px;
      .totalItime_left {
        font-size: 14px;
        line-height: 20px;
        color: #666;
      }
      .totalItime_right {
        font-weight: 500;
        font-size: 24px;
        line-height: 33px;
        color: #333;
        margin-left: 20px;
      }
    }
  }
  .header {
    display: flex;
  }

  ::v-deep .el-form .el-input__inner {
    width: 160px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.Homeboxtop_nav_tab {
  span {
    padding-bottom: 10px;
  }
  // border-bottom: 1px solid #000;
}
</style>
